export default "<h1>Coming soon...</h1>\r\n"